import ILiabilityFinancing from "@/module/main/dto/ILiabilityFinancing";
import LiabilityFinancingType from "@/module/main/dto/LiabilityFinancingTypeEnum";
import ISettingsConsolidation from "@/module/main/dto/ISettingsConsolidation";
import SettingsConsolidation from "@/module/main/dto/SettingsConsolidation";

export default class LiabilityFinancing implements ILiabilityFinancing {
    constructor(
        public consolidation: ISettingsConsolidation = new SettingsConsolidation(),
        public type: LiabilityFinancingType = LiabilityFinancingType.CONSOLIDATION
    ) {}
}
